<template>
  <div class="page-section light-blue-section">
    <h1
      class="info-title red font-32"
    >
      Your monthly <b>net balance</b>
    </h1>
    <h1 class="top-title">
      <span>£</span>{{ numberToHumanReadable(monthlyAvgDisposableIncome.total) }}
    </h1>
    <div class="section-subtitle light-section-text">
      Based on your income and spending, you may have <b>£{{ numberToHumanReadable(monthlyAvgDisposableIncome.total) }}</b> available monthly.
      This is what you might afford to save or use to repay a low-cost loan.
    </div>
    <button
      class="blue-button width-80"
      @click="handleExploreSavingsClick"
    >
      Explore savings accounts <span class="arrow-right">→</span>
    </button>
  </div>
</template>

<script setup>
import { numberToHumanReadable } from '../../../../utils/miscUtils';

defineProps({
  monthlyAvgDisposableIncome: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['explore-savings-click']);

const handleExploreSavingsClick = () => {
  emit('explore-savings-click');
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.page-section {
  color: white;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 35px;
}

.section-subtitle {
  font-size: 17px;
  font-family: 'SalaryFinance';
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.info-title {
  font-size: 36px;
  font-family: 'SalaryFinance';
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.red {
  color: #F14241;
}

.font-32 {
  font-size: 32px;
}

.info-title b {
  font-weight: 700;
}

.blue-button {
  background-color: #002579;
  color: white;
  width: 100%;
  border-radius: 12px;
  padding: 10px 0px;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-family: 'SalaryFinance';
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
  padding-bottom: 18px;
}

.width-80 {
  width: 80%;
}

.arrow-right {
  margin-left: 10px;
  font-family: 'SalaryFinance';
  color: #FD5F5A;
  font-size: 30px;
  vertical-align: sub;
}

.top-title {
  font-size: 67px;
  font-family: 'SalaryFinance';
  line-height: 1;
  color: #002579;
  width: 80%;
  margin-left: 10%;
  text-align: left;
  margin-bottom: 20px;
}

.light-section-text {
  color: #002579;
}

.light-blue-section {
  background-color: #EEF2F8;
  color: #002579;
}
</style>
